<template>
  <span
    class="bg-blue-dark inline-flex items-center text-xs ltr:pl-3 rtl:pr-3 text-white whitespace-no-wrap rounded"
  >
    {{ model.name }}
    <span
      role="button"
      class="inline-flex items-center justify-center h-8 w-8"
      @click="removeTag()"
    >
      <span class="sr-only">Remove Tag</span>
      <IconCross
        height="10px"
        width="10px"
        stroke="white"
      />
    </span>
  </span>
</template>

<script>
import IconCross from '@/assets/icons/icon-cross.svg'

export default {
  components: {
    IconCross
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // iconClose
    }
  },
  methods: {
    removeTag() {
      this.$emit('removeTag', this.model)
    }
  }
}
</script>
